module.exports = __webpack_public_path__ + "static/media/mobi.ff95734f.png";